module.exports = "\n <div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <ng2-ya-table [options]=\"options\" [columns]=\"columns\" [datasource]=\"datasource\" [paging]=\"paging\">\n      </ng2-ya-table>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/dbform/dbform.component.html
// module id = ../../../../../src/app/dbform/dbform.component.html
// module chunks = main